document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('header-drawer');
  if (!drawer) return;

  // Gérer les triggers de sous-menu
  drawer.querySelectorAll('.menu-drawer__submenu-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var submenuId = trigger.getAttribute('data-submenu-id');
      var submenu = drawer.querySelector('#' + CSS.escape(submenuId));
      if (!submenu) return;

      submenu.classList.add('menu-drawer__submenu--open');
      trigger.setAttribute('aria-expanded', 'true');

      var closeBtn = submenu.querySelector('.menu-drawer__submenu-close');
      if (closeBtn) {
        setTimeout(function () { closeBtn.focus(); }, 300);
      }
    });
  });

  // Gérer les boutons de fermeture
  drawer.querySelectorAll('.menu-drawer__submenu-close').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var submenu = button.closest('.menu-drawer__submenu');
      if (!submenu) return;

      submenu.classList.remove('menu-drawer__submenu--open');

      var submenuId = submenu.getAttribute('id');
      var trigger = drawer.querySelector('[data-submenu-id="' + submenuId + '"]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        setTimeout(function () { trigger.focus(); }, 300);
      }
    });
  });
});
